jQuery(document).ready(function ($) {
    $(document).on('click', '.js-pardot-close-thank-you-modal', () => {
        setTimeout(() => $('.js-pardot-thank-you').fadeOut(), 1000);
    });


    const IS_TOUCH_DEVICE = (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));

    var nonces = [];

    window.addEventListener("message", (event) => {
        if (!event.origin.match(/extensis(group|hr).com$/)) {
            return;
        }

        if (!event.data.action || event.data.action !== 'pardot-thank-you-modal') {
            return;
        }

        function trigger_extensis_download_file(url) {
            const link = document.createElement('a');
            link.href = url;
            link.target = '_blank';
            link.download = url.split('/').pop();

            if (IS_TOUCH_DEVICE ||
                navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search(/chrome|macintosh/i) === -1) {
                return;
            }

            if (link.href.indexOf(window.location.host) === -1) {
                window.open(link.href, '_blank');
                return;
            }

            const evt = new MouseEvent('click', {
                'view': window,
                'bubbles': true,
                'cancelable': false
            });

            link.dispatchEvent(evt);

            (window.URL || window.webkitURL).revokeObjectURL(link.href);
        }

        try {
            nonces[event.data.nonce].abort();
        } catch (e) {
        }

        nonces[event.data.nonce] = $.getJSON(`/wp-json/extensis/v1/pardot-response/${event.data.nonce}`).then((data) => {
            if (data.content) {
                $('body').append(data.content);

            // Close exit popup when download popup opens
            if ($('.js-exit.popup')) {
                setTimeout(() => $('.js-exit-popup').fadeOut(), 0);
            }
            }

            if (!!data.auto_download_url) {
                trigger_extensis_download_file(data.auto_download_url);
            }

            setTimeout(() => $('.js-pardot-thank-you').addClass('delay-cta'), 5000);
        }).catch(() => {
            alert('Invalid Nonce.');
        });
    });
})